const authApiEndpoint: string = '';
const userIdentifier: string = JSON.stringify({
	email: '',
	password: '',
});
const getAiResponse = (value: string) => ``;
const getAiSchemaCode = (threadId: string | number, functionId: string | number) => ``;

export { authApiEndpoint, userIdentifier, getAiResponse, getAiSchemaCode };
